<template>
  <div class="animated fadeIn">
    <b-card>
      <h3>{{ $t('detection_set.delete_title') }}</h3>
      <div class="mb-3">
        You are deleting {{ totalDetections }} detections and {{ totalFiles }} files from dataset server.
      </div>
      <div>
        <b-form-checkbox v-model="deleteSchema" value="1" unchecked-value="0">
          Delete json schema? (Other datasets using this schema: {{ detectionSetsUsingSchema }})
        </b-form-checkbox>
      </div>
      <b-button class="mt-3" @click="deleteDetections()" :disabled="deleting">
        <b-spinner v-if="deleting" type="grow" variant="primary" small />
        {{ deleting ? 'Deleting' : 'Delete' }}
      </b-button>
    </b-card>
  </div>
</template>

<script>
import Services from '@/services/index';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      deleteSchema: 0,
      totalFiles: 0,
      totalDetections: 0,
      detectionSetsUsingSchema: 0,
      deleting: false,
      loading: false,
    };
  },
  methods: {
    load() {
      Services.detectionSets.getForDelete(this.$route.params.project_id, this.$route.params.id).then((response) => {
        this.totalFiles = response.data.total_files;
        this.totalDetections = response.data.total_detections;
        this.detectionSetsUsingSchema = response.data.detection_sets_using_schema;
      });
    },
    deleteDetections() {
      this.deleting = true;

      Services.detectionSets.delete(this.$route.params.project_id, this.$route.params.id, {
        delete_schema: this.deleteSchema,
      }).then(() => {
        this.$router.push({ name: 'DetectionSets', params: { project_id: this.$route.params.project_id } });
      });
    },

  }
};
</script>
